import { Box, Grid } from '@mui/material';
import {
    AppWebsiteVisits,
    AppWidgetSummary
} from '../../sections/@dashboard/app';
import i18n from '../../i18n';
import React from 'react';

export default function AdminDashboardContent({ data, isLoading }) {
    const ordersByDate = data?.ordersByDate || [];
    // const paymentOrders = data?.paymentOrders || [];
    const datesLabelsPaymentOrders = data?.datesLabelsPaymentOrders || [];
    const {
        balance,
        debtToMerchants,
        debtToProviders,
        ourCommissions,
        ourCommissionsByDate
    } = data;
    // balance
    const pendingBalance = balance?.pendingBalance || 0;
    const receivedBalance = balance?.receivedBalance || 0;
    const totalBalance = balance?.totalBalance || 0;

    // debt to merchants
    const totalDebtToMerchants = debtToMerchants?.totalDebtToMerchants || 0;
    const totalDebtToMerchantsCovered =
        debtToMerchants?.totalDebtToMerchantsCovered || 0;
    const totalDebtToMerchantsNotCovered =
        debtToMerchants?.totalDebtToMerchantsNotCovered || 0;

    // debt to providers
    const totalDebtToProviders = debtToProviders?.totalDebtToProviders || 0;
    const totalDebtToProvidersCovered =
        debtToProviders?.totalDebtToProvidersCovered || 0;
    const totalDebtToProvidersNotCovered =
        debtToProviders?.totalDebtToProvidersNotCovered || 0;

    // our commissions
    const totalOurCommissions = ourCommissions?.totalOurCommissions || 0;
    const totalOurCommissionsReceived =
        ourCommissions?.totalOurCommissionsReceived || 0;
    const totalOurCommissionsNotReceived =
        ourCommissions?.totalOurCommissionsNotReceived || 0;

    // our commissions
    const totalOurCommissionsLast24Hours =
        ourCommissionsByDate?.totalOurCommissionsLast24Hours || 0;
    const totalOurCommissionsAverageLast30Days =
        ourCommissionsByDate?.totalOurCommissionsAverageLast30Days || 0;
    const totalOurCommissionsCurrentWeek =
        ourCommissionsByDate?.totalOurCommissionsCurrentWeek || 0;
    const totalOurCommissionsByGeo =
        ourCommissionsByDate?.totalOurCommissionsByGeo || 0;
    return (
        <div>
            <Box
                display="flex"
                justifyContent="space-between"
                mb={3}
                gap={2}
                flexWrap={{
                    xs: 'wrap',
                    sm: 'wrap',
                    md: 'nowrap'
                }}
            >
                <Box flexBasis="100%">
                    <AppWidgetSummary
                        loading={isLoading}
                        title={i18n.t('dashboard.balance.title')}
                        list={[
                            {
                                title: i18n.t(
                                    'dashboard.balance.details.total.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.balance.details.total.tooltip'
                                ),
                                amount: totalBalance
                            },
                            {
                                title: i18n.t(
                                    'dashboard.balance.details.pending.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.balance.details.pending.tooltip'
                                ),
                                amount: pendingBalance
                            },
                            {
                                title: i18n.t(
                                    'dashboard.balance.details.received.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.balance.details.received.tooltip'
                                ),
                                amount: receivedBalance
                            }
                        ]}
                    />
                </Box>

                <Box flexBasis="100%">
                    <AppWidgetSummary
                        loading={isLoading}
                        title={i18n.t('dashboard.debtToMerchants.title')}
                        list={[
                            {
                                title: i18n.t(
                                    'dashboard.debtToMerchants.details.total.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToMerchants.details.total.tooltip'
                                ),
                                amount: totalDebtToMerchants
                            },
                            {
                                title: i18n.t(
                                    'dashboard.debtToMerchants.details.covered.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToMerchants.details.covered.tooltip'
                                ),
                                amount: totalDebtToMerchantsCovered
                            },
                            {
                                title: i18n.t(
                                    'dashboard.debtToMerchants.details.notCovered.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToMerchants.details.notCovered.tooltip'
                                ),
                                amount: totalDebtToMerchantsNotCovered
                            }
                        ]}
                        color="info"
                    />
                </Box>

                <Box flexBasis="100%">
                    <AppWidgetSummary
                        loading={isLoading}
                        title={i18n.t('dashboard.debtToProviders.title')}
                        list={[
                            {
                                title: i18n.t(
                                    'dashboard.debtToProviders.details.total.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToProviders.details.total.tooltip'
                                ),
                                amount: totalDebtToProviders
                            },
                            {
                                title: i18n.t(
                                    'dashboard.debtToProviders.details.covered.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToProviders.details.covered.tooltip'
                                ),
                                amount: totalDebtToProvidersCovered
                            },
                            {
                                title: i18n.t(
                                    'dashboard.debtToProviders.details.notCovered.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.debtToProviders.details.notCovered.tooltip'
                                ),
                                amount: totalDebtToProvidersNotCovered
                            }
                        ]}
                        color="secondary"
                    />
                </Box>

                <Box flexBasis="100%">
                    <AppWidgetSummary
                        loading={isLoading}
                        title={i18n.t('dashboard.ourCommissions.title')}
                        list={[
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.details.total.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.details.total.tooltip'
                                ),
                                amount: totalOurCommissions
                            },
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.details.received.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.details.received.tooltip'
                                ),
                                amount: totalOurCommissionsReceived
                            },
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.details.notReceived.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.details.notReceived.tooltip'
                                ),
                                amount: totalOurCommissionsNotReceived
                            }
                        ]}
                        color="warning"
                    />
                </Box>

                <Box flexBasis="100%">
                    <AppWidgetSummary
                        loading={isLoading}
                        title={i18n.t('dashboard.ourCommissions.title')}
                        list={[
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.additional.last24Hours.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.additional.last24Hours.tooltip'
                                ),
                                amount: totalOurCommissionsLast24Hours
                            },
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.additional.averageLast30Days.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.additional.averageLast30Days.tooltip'
                                ),
                                amount: totalOurCommissionsAverageLast30Days
                            },
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.additional.currentWeek.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.additional.currentWeek.tooltip'
                                ),
                                amount: totalOurCommissionsCurrentWeek
                            },
                            {
                                title: i18n.t(
                                    'dashboard.ourCommissions.additional.byGeo.title'
                                ),
                                tooltip: i18n.t(
                                    'dashboard.ourCommissions.additional.byGeo.tooltip'
                                ),
                                amount: totalOurCommissionsByGeo
                            }
                        ]}
                        color="success"
                    />
                </Box>
            </Box>
            <Grid container spacing={3} alignItems="stretch">
                <Grid item xs={12}>
                    <AppWebsiteVisits
                        loading={isLoading}
                        title={i18n.t('dashboard.ordersByDate')}
                        subheader=""
                        chartLabels={datesLabelsPaymentOrders}
                        chartData={Object.entries(ordersByDate).map((field) => {
                            return {
                                name: i18n.t(`dashboard.${field[0]}`),
                                type: 'line',
                                fill: 'solid',
                                data: field[1]
                            };
                        })}
                    />
                </Grid>

            </Grid>
        </div>
    );
}
